"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const mobx_1 = require("mobx");
const search_1 = require("@App/api/routes/search");
class OverclaimSearchCriteriaStore extends search_criteria_store_1.default {
    constructor(criteria, options, optionType, requiredCriteria, maxCriteria, rightsholderStore) {
        super(criteria, options, optionType, requiredCriteria, maxCriteria);
        Object.defineProperty(this, "rightsholderStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.rightsholderStore = rightsholderStore;
    }
    searchAutoCompleteSuggestions(property, searchTerm) {
        return __awaiter(this, void 0, void 0, function* () {
            const cleanSearch = encodeURIComponent(searchTerm).toLowerCase();
            const suggestions = yield (0, search_1.searchOverclaimsRHSuggestions)(this.rightsholderStore.currentRightsholderId, property, cleanSearch);
            (0, mobx_1.runInAction)(() => (this._autoCompleteSuggestions = suggestions.data));
        });
    }
}
exports.default = OverclaimSearchCriteriaStore;
